const state = {
    owner: true
}

export default {
    namespaced: true,
    state,
};